import { render, staticRenderFns } from "./dashboard-org_admin.vue?vue&type=template&id=b4a1fa7e&scoped=true"
import script from "./dashboard-org_admin.vue?vue&type=script&lang=js"
export * from "./dashboard-org_admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a1fa7e",
  null
  
)

export default component.exports